module.exports = __WEBPACK_EXTERNAL_MODULE_41__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-catalog"
// module id = 41
// module chunks = 0